module.exports = __webpack_public_path__ + "static/img/bottom.72eb516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/bottom.png
// module id = oLGQ
// module chunks = 0